module.exports = __webpack_public_path__ + "assets/video-listview-icon.6923984b.svg";